// extracted by mini-css-extract-plugin
export default {"fadeIn":"FirstImageDIv_fadeIn__EqKFp","fadeInOpacity":"FirstImageDIv_fadeInOpacity__jDsus"};